<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Promo2019Pact from './Promo2019_Pact.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsPromo2019Pact = Promo2019Pact.data().items

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-12-02',
        major: [ 'みらいコレクション', 'まりあコレクション', '共通' ],
        excepts: [
        ],
        items: [

          // [NOTE] JR1
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'JR1-01',
            rare        : 'JR',
            name        : 'ときめきのピンクジュエルドレス',
            imgUrl      : '/images/items/JR1-01.png',
            numOwned    : { usual: 1, kira: 2 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-02',
            rare        : 'JR',
            name        : 'ときめきのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR1-02.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-03',
            rare        : 'JR',
            name        : 'ときめきのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-04',
            rare        : 'JR',
            name        : 'ときめきのイエロージュエルドレス',
            imgUrl      : '/images/items/JR1-04.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-05',
            rare        : 'JR',
            name        : 'ときめきのイエロージュエルシューズ',
            imgUrl      : '/images/items/JR1-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-06',
            rare        : 'JR',
            name        : 'ときめきのイエロージュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-06.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-07',
            rare        : 'JR',
            name        : 'ときめきのブルージュエルドレス',
            imgUrl      : '/images/items/JR1-07.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-08',
            rare        : 'JR',
            name        : 'ときめきのブルージュエルシューズ',
            imgUrl      : '/images/items/JR1-08.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-09',
            rare        : 'JR',
            name        : 'ときめきのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-09.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-10',
            rare        : 'JR',
            name        : 'ときめきのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR1-10.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-11',
            rare        : 'JR',
            name        : 'ときめきのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR1-11.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-12',
            rare        : 'JR',
            name        : 'ときめきのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-12.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-13',
            rare        : 'JR',
            name        : 'ときめきのブラックジュエルドレス',
            imgUrl      : '/images/items/JR1-13.png',
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-14',
            rare        : 'JR',
            name        : 'ときめきのブラックジュエルシューズ',
            imgUrl      : '/images/items/JR1-14.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-15',
            rare        : 'JR',
            name        : 'ときめきのブラックジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-15.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-16',
            rare        : 'JR',
            name        : 'ときめきのレッドジュエルドレス',
            imgUrl      : '/images/items/JR1-16.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-17',
            rare        : 'JR',
            name        : 'ときめきのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR1-17.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-18',
            rare        : 'JR',
            name        : 'ときめきのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-18.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-19',
            rare        : 'JR',
            name        : 'ときめきのグリーンジュエルドレス',
            imgUrl      : '/images/items/JR1-19.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-20',
            rare        : 'JR',
            name        : 'ときめきのグリーンジュエルシューズ',
            imgUrl      : '/images/items/JR1-20.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-21',
            rare        : 'JR',
            name        : 'ときめきのグリーンジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-21.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-22',
            rare        : 'JR',
            name        : 'ときめきのパープルジュエルドレス',
            imgUrl      : '/images/items/JR1-22.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-23',
            rare        : 'JR',
            name        : 'ときめきのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR1-23.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-24',
            rare        : 'JR',
            name        : 'ときめきのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-24.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-25',
            rare        : 'JR',
            name        : 'ときめきのホワイトジュエルドレス',
            imgUrl      : '/images/items/JR1-25.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-26',
            rare        : 'JR',
            name        : 'ときめきのホワイトジュエルシューズ',
            imgUrl      : '/images/items/JR1-26.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-27',
            rare        : 'JR',
            name        : 'ときめきのホワイトジュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-27.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          item({
            collection  : '共通',
            id          : 'JR1-28',
            rare        : 'JR',
            name        : 'ときめきのレインボージュエルドレス',
            imgUrl      : '/images/items/JR1-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-29',
            rare        : 'JR',
            name        : 'ときめきのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR1-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'JR1-30',
            rare        : 'JR',
            name        : 'ときめきのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR1-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'JR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'みらいコレクション',
            id          : 'J1-01',
            rare        : 'HR',
            name        : 'しらゆきひめワンピ',
            imgUrl      : '/images/items/J1-01.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-02',
            rare        : 'HR',
            name        : 'しらゆきひめシューズ',
            imgUrl      : '/images/items/J1-02.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-03',
            rare        : 'HR',
            name        : 'しらゆきひめヘアアクセ',
            imgUrl      : '/images/items/J1-03.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'まりあコレクション',
            id          : 'J1-65',
            rare        : 'HR',
            name        : 'しらゆきひめクラシックワンピ',
            imgUrl      : '/images/items/J1-65.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-66',
            rare        : 'HR',
            name        : 'しらゆきひめクラシックシューズ',
            imgUrl      : '/images/items/J1-66.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-67',
            rare        : 'HR',
            name        : 'しらゆきひめクラシックヘアアクセ',
            imgUrl      : '/images/items/J1-67.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'みらいコレクション',
            id          : 'J1-04',
            rare        : 'PR',
            name        : 'ミラクルアイドルラブリートップス',
            imgUrl      : '/images/items/J1-04.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-05',
            rare        : 'PR',
            name        : 'ミラクルアイドルラブリースカート',
            imgUrl      : '/images/items/J1-05.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-06',
            rare        : 'PR',
            name        : 'ミラクルアイドルラブリーシューズ',
            imgUrl      : '/images/items/J1-06.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-07',
            rare        : 'PR',
            name        : 'ミラクルアイドルラブリーヘアアクセ',
            imgUrl      : '/images/items/J1-07.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'みらいコレクション',
            id          : 'J1-08',
            rare        : 'PR',
            name        : 'はあと♡パールワンピ',
            imgUrl      : '/images/items/J1-08.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-09',
            rare        : 'PR',
            name        : 'はあと♡パールシューズ',
            imgUrl      : '/images/items/J1-09.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-10',
            rare        : 'PR',
            name        : 'はあと♡パールヘアアクセ',
            imgUrl      : '/images/items/J1-10.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            rare        : 'PR',
          }),


          item({
            collection  : 'まりあコレクション',
            id          : 'J1-68',
            rare        : 'PR',
            name        : 'ミラクルアイドルポップトップス',
            imgUrl      : '/images/items/J1-68.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-69',
            rare        : 'PR',
            name        : 'ミラクルアイドルポップパンツ',
            imgUrl      : '/images/items/J1-69.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-70',
            rare        : 'PR',
            name        : 'ミラクルアイドルポップシューズ',
            imgUrl      : '/images/items/J1-70.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-71',
            rare        : 'PR',
            name        : 'ミラクルアイドルポップヘアアクセ',
            imgUrl      : '/images/items/J1-71.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'まりあコレクション',
            id          : 'J1-72',
            rare        : 'PR',
            name        : 'はあと♡パールおれんじワンピ',
            imgUrl      : '/images/items/J1-72.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-73',
            rare        : 'PR',
            name        : 'はあと♡パールおれんじシューズ',
            imgUrl      : '/images/items/J1-73.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-74',
            rare        : 'PR',
            name        : 'はあと♡パールおれんじヘアアクセ',
            imgUrl      : '/images/items/J1-74.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'みらいコレクション',
            id          : 'J1-11',
            rare        : 'SR',
            name        : 'さくらひめももトップス',
            imgUrl      : '/images/items/J1-11.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-12',
            rare        : 'SR',
            name        : 'さくらひめももスカート',
            imgUrl      : '/images/items/J1-12.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-13',
            rare        : 'SR',
            name        : 'さくらひめももシューズ',
            imgUrl      : '/images/items/J1-13.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-14',
            rare        : 'SR',
            name        : 'さくらひめももヘアアクセ',
            imgUrl      : '/images/items/J1-14.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'みらいコレクション',
            id          : 'J1-15',
            rare        : 'SR',
            name        : 'クローバーファンタジーイエロートップス',
            imgUrl      : '/images/items/J1-15.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-16',
            rare        : 'SR',
            name        : 'クローバーファンタジーイエロースカート',
            imgUrl      : '/images/items/J1-16.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-17',
            rare        : 'SR',
            name        : 'クローバーファンタジーイエローシューズ',
            imgUrl      : '/images/items/J1-17.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-18',
            rare        : 'SR',
            name        : 'クローバーファンタジーイエローヘアアクセ',
            imgUrl      : '/images/items/J1-18.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'みらいコレクション',
            id          : 'J1-54',
            rare        : 'SR',
            name        : 'ファントミハートココミワンピ',
            imgUrl      : '/images/items/J1-54.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-55',
            rare        : 'SR',
            name        : 'ファントミハートココミシューズ',
            imgUrl      : '/images/items/J1-55.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-56',
            rare        : 'SR',
            name        : 'ファントミハートココミヘアアクセ',
            imgUrl      : '/images/items/J1-56.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'まりあコレクション',
            id          : 'J1-75',
            rare        : 'SR',
            name        : 'さくらひめすみれトップス',
            imgUrl      : '/images/items/J1-75.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-76',
            rare        : 'SR',
            name        : 'さくらひめすみれスカート',
            imgUrl      : '/images/items/J1-76.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-77',
            rare        : 'SR',
            name        : 'さくらひめすみれシューズ',
            imgUrl      : '/images/items/J1-77.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-78',
            rare        : 'SR',
            name        : 'さくらひめすみれヘアアクセ',
            imgUrl      : '/images/items/J1-78.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR 期間限定追加
          // ================================================================================

          item({
            collection  : 'まりあコレクション期間限定追加',
            id          : 'J1-88',
            rare        : 'SR',
            name        : 'RONIチェリーギンガムトップス',
            imgUrl      : '/images/items/J1-88.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション期間限定追加',
            id          : 'J1-89',
            rare        : 'SR',
            name        : 'RONIチェリーギンガムスカート',
            imgUrl      : '/images/items/J1-89.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション期間限定追加',
            id          : 'J1-90',
            rare        : 'SR',
            name        : 'RONIチェリーギンガムシューズ',
            imgUrl      : '/images/items/J1-90.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション期間限定追加',
            id          : 'J1-91',
            rare        : 'SR',
            name        : 'RONIチェリーギンガムヘアアクセ',
            imgUrl      : '/images/items/J1-91.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'まりあコレクション期間限定追加',
            id          : 'J1-92',
            rare        : 'SR',
            name        : 'BANANA CHIPSベリーワンピ',
            imgUrl      : '/images/items/J1-92.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション期間限定追加',
            id          : 'J1-93',
            rare        : 'SR',
            name        : 'BANANA CHIPSリボンシューズ',
            imgUrl      : '/images/items/J1-93.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション期間限定追加',
            rare        : 'SR',
          }),
          item({
            collection  : 'まりあコレクション期間限定追加',
            rare        : 'SR',
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-17',
            rare        : 'SR',
            name        : 'ミラクルアイドルレッドトップス',
            imgUrl      : '/images/items/MF-17.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-18',
            rare        : 'SR',
            name        : 'ミラクルアイドルレッドスカート',
            imgUrl      : '/images/items/MF-18.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-19',
            rare        : 'SR',
            name        : 'ミラクルアイドルレッドシューズ',
            imgUrl      : '/images/items/MF-19.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-20',
            rare        : 'SR',
            name        : 'ミラクルアイドルレッドヘアアクセ',
            imgUrl      : '/images/items/MF-20.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'みらいコレクション',
            id          : 'J1-20',
            rare        : 'R',
            name        : 'デニムリボンテディベアブルーワンピ',
            imgUrl      : '/images/items/J1-20.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-21',
            rare        : 'R',
            name        : 'デニムリボンピンクパンプス',
            imgUrl      : '/images/items/J1-21.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-22',
            rare        : 'R',
            name        : 'デニムリボンヘアアクセ',
            imgUrl      : '/images/items/J1-22.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'みらいコレクション',
            id          : 'J1-23',
            rare        : 'R',
            name        : 'スクールスターポロシャツ＆スカート',
            imgUrl      : '/images/items/J1-23.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-24',
            rare        : 'R',
            name        : 'スクールスタースニーカー',
            imgUrl      : '/images/items/J1-24.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-25',
            rare        : 'R',
            name        : 'スクールスターヘアアクセ',
            imgUrl      : '/images/items/J1-25.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'みらいコレクション',
            id          : 'J1-26',
            rare        : 'R',
            name        : 'クラッシーレッドチェックブラウス',
            imgUrl      : '/images/items/J1-26.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-27',
            rare        : 'R',
            name        : 'クラッシーレッドチェックスカート',
            imgUrl      : '/images/items/J1-27.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-28',
            rare        : 'R',
            name        : 'クラッシーレッドチェックパンプス',
            imgUrl      : '/images/items/J1-28.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-29',
            rare        : 'R',
            name        : 'クラッシーブラックヘアアクセ',
            imgUrl      : '/images/items/J1-29.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'まりあコレクション',
            id          : 'J1-80',
            rare        : 'R',
            name        : 'クラブストライプトップス',
            imgUrl      : '/images/items/J1-80.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-81',
            rare        : 'R',
            name        : 'クラブストライプスカート',
            imgUrl      : '/images/items/J1-81.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-82',
            rare        : 'R',
            name        : 'クラブストライプシューズ',
            imgUrl      : '/images/items/J1-82.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-83',
            rare        : 'R',
            name        : 'クラブストライプヘアアクセ',
            imgUrl      : '/images/items/J1-83.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'まりあコレクション',
            id          : 'J1-84',
            rare        : 'R',
            name        : 'ゆるふわラブリーアクアワンピ',
            imgUrl      : '/images/items/J1-84.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-85',
            rare        : 'R',
            name        : 'ゆるふわラブリーパンプス',
            imgUrl      : '/images/items/J1-85.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-86',
            rare        : 'R',
            name        : 'ゆるふわラブリーカチューシャ',
            imgUrl      : '/images/items/J1-86.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            rare        : 'R',
          }),


          item({
            collection  : '共通',
            id          : 'J1-31',
            rare        : 'R',
            name        : 'ピクニックギンガムグリーンケープワンピ',
            imgUrl      : '/images/items/J1-31.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-32',
            rare        : 'R',
            name        : 'ピクニックギンガムグリーンシューズ',
            imgUrl      : '/images/items/J1-32.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-33',
            rare        : 'R',
            name        : 'ピクニックギンガムグリーンヘアアクセ',
            imgUrl      : '/images/items/J1-33.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          item({
            collection  : '共通',
            id          : 'J1-34',
            rare        : 'R',
            name        : 'きまぐれカウガールトップス',
            imgUrl      : '/images/items/J1-34.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-35',
            rare        : 'R',
            name        : 'きまぐれカウガールパンツ',
            imgUrl      : '/images/items/J1-35.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-36',
            rare        : 'R',
            name        : 'きまぐれカウガールシューズ',
            imgUrl      : '/images/items/J1-36.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-37',
            rare        : 'R',
            name        : 'きまぐれカウガールヘアアクセ',
            imgUrl      : '/images/items/J1-37.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J1-38',
            rare        : 'R',
            name        : 'キラキラフィーバーレッドトップス',
            imgUrl      : '/images/items/J1-38.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-39',
            rare        : 'R',
            name        : 'キラキラフィーバーレッドスカート',
            imgUrl      : '/images/items/J1-39.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-40',
            rare        : 'R',
            name        : 'キラキラフィーバーレッドシューズ',
            imgUrl      : '/images/items/J1-40.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-41',
            rare        : 'R',
            name        : 'キラキラフィーバーレッドヘアアクセ',
            imgUrl      : '/images/items/J1-41.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J1-42',
            rare        : 'N',
            name        : 'ガールズマーチトップス',
            imgUrl      : '/images/items/J1-42.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-43',
            rare        : 'N',
            name        : 'ガールズマーチスカート',
            imgUrl      : '/images/items/J1-43.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-44',
            rare        : 'N',
            name        : 'ガールズマーチシューズ',
            imgUrl      : '/images/items/J1-44.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-45',
            rare        : 'N',
            name        : 'ガールズマーチヘアアクセ',
            imgUrl      : '/images/items/J1-45.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J1-46',
            rare        : 'N',
            name        : 'ハート＆レースブルートップス',
            imgUrl      : '/images/items/J1-46.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-47',
            rare        : 'N',
            name        : 'ハート＆レースブルースカート',
            imgUrl      : '/images/items/J1-47.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-48',
            rare        : 'N',
            name        : 'ハート＆レースブルーシューズ',
            imgUrl      : '/images/items/J1-48.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-49',
            rare        : 'N',
            name        : 'ハート＆レースブルーヘアアクセ',
            imgUrl      : '/images/items/J1-49.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J1-50',
            rare        : 'N',
            name        : 'ポリスガールトップス',
            imgUrl      : '/images/items/J1-50.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-51',
            rare        : 'N',
            name        : 'ポリスガールパンツ',
            imgUrl      : '/images/items/J1-51.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-52',
            rare        : 'N',
            name        : 'ポリスガールシューズ',
            imgUrl      : '/images/items/J1-52.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J1-53',
            rare        : 'N',
            name        : 'ポリスガールヘアアクセ',
            imgUrl      : '/images/items/J1-53.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ブランドランク
          // ================================================================================

          item({
            collection  : 'ブランドランク',
            id          : 'CH-01',
            rare        : 'R',
            name        : 'ゆるふわラブリーいちごワンピ',
            imgUrl      : '/images/items/CH-01.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'CH-02',
            rare        : 'R',
            name        : 'ゆるふわラブリーいちごパンプス',
            imgUrl      : '/images/items/CH-02.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'CH-03',
            rare        : 'R',
            name        : 'ゆるふわラブリーいちごヘアアクセ',
            imgUrl      : '/images/items/CH-03.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            rare        : 'R',
          }),


          item({
            collection  : 'ブランドランク',
            id          : 'SH-11',
            rare        : 'SR',
            name        : 'さくらひめさんごトップス',
            imgUrl      : '/images/items/SH-11.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'SH-12',
            rare        : 'SR',
            name        : 'さくらひめさんごスカート',
            imgUrl      : '/images/items/SH-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'SH-13',
            rare        : 'SR',
            name        : 'さくらひめさんごシューズ',
            imgUrl      : '/images/items/SH-13.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'SH-14',
            rare        : 'SR',
            name        : 'さくらひめさんごヘアアクセ',
            imgUrl      : '/images/items/SH-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-01',
            rare        : 'SR',
            name        : 'アイスクリームミントワンピ',
            imgUrl      : '/images/items/PB-01.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-02',
            rare        : 'SR',
            name        : 'アイスクリームミントシューズ',
            imgUrl      : '/images/items/PB-02.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-03',
            rare        : 'SR',
            name        : 'アイスクリームミントヘアアクセ',
            imgUrl      : '/images/items/PB-03.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'SR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-04',
            rare        : 'SR',
            name        : 'スマイルマーチトップス',
            imgUrl      : '/images/items/PB-04.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-05',
            rare        : 'SR',
            name        : 'スマイルマーチスカート',
            imgUrl      : '/images/items/PB-05.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-06',
            rare        : 'SR',
            name        : 'スマイルマーチシューズ',
            imgUrl      : '/images/items/PB-06.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-07',
            rare        : 'SR',
            name        : 'スマイルマーチヘアアクセ',
            imgUrl      : '/images/items/PB-07.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] イースターコーデチャンネル
          // ================================================================================

          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-57',
            rare        : 'SR',
            name        : 'イースターピンクうさぎトップス',
            imgUrl      : '/images/items/J1-57.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-58',
            rare        : 'SR',
            name        : 'イースターピンクうさぎスカート',
            imgUrl      : '/images/items/J1-58.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-59',
            rare        : 'SR',
            name        : 'イースターピンクうさぎシューズ',
            imgUrl      : '/images/items/J1-59.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-60',
            rare        : 'SR',
            name        : 'イースターピンクうさぎヘアアクセ',
            imgUrl      : '/images/items/J1-60.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-61',
            rare        : 'SR',
            name        : 'イースターグレーうさぎトップス',
            imgUrl      : '/images/items/J1-61.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-62',
            rare        : 'SR',
            name        : 'イースターグレーうさぎスカート',
            imgUrl      : '/images/items/J1-62.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-63',
            rare        : 'SR',
            name        : 'イースターグレーうさぎシューズ',
            imgUrl      : '/images/items/J1-63.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'イースターコーデチャンネル',
            id          : 'J1-64',
            rare        : 'SR',
            name        : 'イースターグレーうさぎヘアアクセ',
            imgUrl      : '/images/items/J1-64.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] まりあのクローバーファンタジーチャンネル
          // ================================================================================

          item({
            collection  : 'まりあのクローバーファンタジーチャンネル',
            id          : 'J1-94',
            rare        : 'SR',
            name        : 'クローバーファンタジーグリーントップス',
            imgUrl      : '/images/items/J1-94.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあのクローバーファンタジーチャンネル',
            id          : 'J1-95',
            rare        : 'SR',
            name        : 'クローバーファンタジーグリーンスカート',
            imgUrl      : '/images/items/J1-95.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあのクローバーファンタジーチャンネル',
            id          : 'J1-96',
            rare        : 'SR',
            name        : 'クローバーファンタジーグリーンシューズ',
            imgUrl      : '/images/items/J1-96.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあのクローバーファンタジーチャンネル',
            id          : 'J1-97',
            rare        : 'SR',
            name        : 'クローバーファンタジーグリーンヘアアクセ',
            imgUrl      : '/images/items/J1-97.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'みらいコレクション',
            id          : 'J1-19',
            rare        : 'SR',
            name        : 'ティーカップ＆ソーサー',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J1-19.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'みらいコレクション',
            id          : 'J1-30',
            rare        : 'R',
            name        : 'ミントハートのシャボンだまセット',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J1-30.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-87',
            rare        : 'R',
            name        : 'まっかなりんご',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J1-87.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'まりあコレクション',
            id          : 'J1-79',
            rare        : 'SR',
            name        : 'おきにいりカメラ',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J1-79.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] フォロトモポイント
          // ================================================================================

          item({
            collection  : 'フォロトモポイント',
            id          : 'J1-98',
            rare        : 'SR',
            name        : 'おきにいりカメラオフホワイト',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J1-98.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フォロトモポイント',
            rare        : 'SR',
          }),
          item({
            collection  : 'フォロトモポイント',
            rare        : 'SR',
          }),
          item({
            collection  : 'フォロトモポイント',
            rare        : 'SR',
          }),


          // [NOTE] ジュエルパクト
          // ================================================================================

          externalItem(itemsPromo2019Pact, 'P-072', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'P-072', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'P-074', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-001', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-002', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-003', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-007', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-008', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-009', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-010', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-011', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-012', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-013', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-014', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-015', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),

          externalItem(itemsPromo2019Pact, 'JP-020', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-021', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-022', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-023', { collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-036', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-037', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-038', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-039', { collection: 'ジュエルパクト' }),

        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, items, itemsPasha } = this
        return _
          .chain(major)
          .map(collection => _.where(items, { collection }))
          .flatten()
          .difference(itemsPasha)
          .value()
      },

      itemsJR () {
        return _.where(this.itemsMaJor, { rare: 'JR' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, { rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' })
      },

      itemsJewelPact () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルパクト' })
      },

      itemsBrandRank () {
        return _.where(this.itemsFiltered, { collection: 'ブランドランク' })
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsEaster () {
        return _.where(this.itemsFiltered, { collection: 'イースターコーデチャンネル' })
      },

      itemsMariaClover () {
        return _.where(this.itemsFiltered, { collection: 'まりあのクローバーファンタジーチャンネル' })
      },

      itemsMariaPeriodLimited () {
        return _.where(this.itemsFiltered, { collection: 'まりあコレクション期間限定追加' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#edd50f" :items="itemsJR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>
    <template #col2>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="SR 期間限定追加 ★★" color="#00c7da" :items="itemsMariaPeriodLimited" />
      <ItemList title="SR モーリー限定 ★★" color="#55b272" :items="itemsMolly" />
    </template>
    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>
    <template #col4>
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="イースターコーデチャンネル" color="#c598ff" :items="itemsEaster" />
      <ItemList title="まりあのクローバーファンタジーチャンネル" color="#c598ff" :items="itemsMariaClover" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>
    <template #col5>
      <ItemList title="ジュエルパクト" color="#a1c0fa" :items="itemsJewelPact" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (HR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(2) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 10;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(1) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 10;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(2) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 10;
    }
  }

  // コレクショングループ間の間隔 (R)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16),
    .Item:nth-child(21),
    .Item:nth-child(22),
    .Item:nth-child(23),
    .Item:nth-child(24) {
      margin-top: $size-unit * 10;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }
</style>
